import { ref } from "vue";
import { defineStore } from "pinia";
import type { Nft } from "@/shared/types/integrations/CoinGecko/Nft";
import type { NftDetail } from "@/shared/types/integrations/CoinGecko/NftDetail";

export const useNftStore = defineStore("nft", () => {
	const nfts = ref<Nft[]>([]);
	const homeTopsTableNfts = ref<Nft[]>([]);
	const nftsDetails = ref<Record<string, NftDetail>>({});

	function addNfts(nftArray: Nft[]): void {
		nfts.value.push(...nftArray);
	}

	function setHomeTopsTableNfts(nftArray: Nft[]): void {
		homeTopsTableNfts.value = nftArray;
	}

	function getNft(id: string): Nft | null {
		return nfts.value.find((nft) => nft.id === id) || null;
	}

	function addNftDetail(nftDetail: NftDetail, id: string): void {
		nftsDetails.value[id] = nftDetail;
	}

	function getNftDetail(id: string): NftDetail | null {
		return nftsDetails.value[id] || null;
	}

	function setNftDetail(id: string, nftDetail: NftDetail): void {
		nftsDetails.value[id] = nftDetail;
	}

	return {
		nfts,
		homeTopsTableNfts,
		nftsDetails,
		addNfts,
		setHomeTopsTableNfts,
		getNft,
		addNftDetail,
		getNftDetail,
		setNftDetail,
	};
});
